import { onMounted, ref, type Ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useSharedApi } from '../../../api/shared.api';
import type { HtmlContent } from '../models/html-content.model';
import type { HtmlContentConfig } from '../models/html-content-config.model';

export const useHtmlContent = (config: HtmlContentConfig) => {
  const htmlContentApi = useSharedApi().htmlContent;

  const htmlContent: Ref<HtmlContent | undefined> = ref(undefined);

  const { t } = useI18n();

  onMounted(async () => {
    await loadHtmlContent();
  });

  const loadHtmlContent = async (updatedKey?: string) => {
    if (config.html) {
      htmlContent.value = { html: config.html };
    }

    const key = updatedKey ?? config.key;
    if (key) {
      try {
        const response = await htmlContentApi.loadContent(key, 'hu');

        htmlContent.value = response.data || htmlContent.value;
      } catch {
        htmlContent.value = { html: t('htmlContent.loadingError') };
      }
    }
  };

  return {
    htmlContent,
    loadHtmlContent
  };
};
